import { PatientDTO } from '@dto/patient/PatientDTO';
import { PatientInsuranceType } from '@enum/patient/PatientInsuranceType';

export class PatientAdminPageEntityDTO extends PatientDTO {
  public ePrescriptions: number;

  public insuranceType: PatientInsuranceType;

  public videoCalls: number;
}